import { createContext, SetStateAction, useContext, useState } from "react";

interface ReceiveMailsContextType {
  isReceiveNoticeMail: boolean;
  isReceiveErrorMail: boolean;
  setIsReceiveNoticeMail: React.Dispatch<SetStateAction<boolean>>;
  setIsReceiveErrorMail: React.Dispatch<SetStateAction<boolean>>;
}

const ReceiveMailsContext = createContext<ReceiveMailsContextType | undefined>(undefined);

export const ReceiveMailsProvider = ({children}: {children: React.ReactNode}) => {
  const [isReceiveNoticeMail, setIsReceiveNoticeMail] = useState(false);
  const [isReceiveErrorMail, setIsReceiveErrorMail] = useState(false);

  return (
    <ReceiveMailsContext.Provider
      value={{
        isReceiveNoticeMail,
        isReceiveErrorMail,
        setIsReceiveNoticeMail,
        setIsReceiveErrorMail,
      }}
    >
      {children}
    </ReceiveMailsContext.Provider>
  );
};

export const useReceiveMailsContext = () => {
  const context = useContext(ReceiveMailsContext);
  if (!context) throw new Error("ReceiveMailsContext must be used within ReceiveMailsProvider");
  return context;
};